// extracted by mini-css-extract-plugin
export var icon = "_5a-1";
export var subtext = "_5a-0";